module.exports = __webpack_public_path__ + "img/horizontal_4_5_pp23_8023.e1f2ce21.png";